export const zIndex = {
    chip: 66,
    header: -1,
    navigationHeader: 99,
    burger: 100,
    sphere: -99,
};
